import './index.css';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { env } from '@/config/env.ts';

import App from './app.tsx';

if (env.BUGSNAG_API_KEY && env.BUGSNAG_RELEASE_STAGE) {
  Bugsnag.start({
    apiKey: env.BUGSNAG_API_KEY,
    appVersion: env.APP_VERSION,
    plugins: [new BugsnagPluginReact()],
    releaseStage: env.BUGSNAG_RELEASE_STAGE
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
